import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/js/utils/constants'
declare module 'vue-router' {
    interface RouteMeta {
        isProtected?: boolean
        noLayout?: boolean
        hasGradientHeader?: boolean
        // layout?: 'auth'
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // interface RouteParams {}
}
import NotFound from '@/views/Pages/NotFound.vue'
import Login from '@/views/Pages/Auth/Login.vue'
import useUser from '@/js/hooks/useUser'
const ForgotPassword = () => import('@/views/Pages/Auth/PasswordForgot.vue')
const Profile = () => import('@/views/Pages/Profile.vue')
const HoldingList = () => import('@/views/Pages/Holding/HoldingList.vue')
const HoldingEdit = () => import('@/views/Pages/Holding/HoldingEdit.vue')
const CompanyList = () => import('@/views/Pages/Company/CompanyList.vue')
const CompanyEdit = () => import('@/views/Pages/Company/CompanyEdit.vue')
const CompanyProduction = () => import('@/views/Pages/Company/CompanyProduction.vue')
const CompanyAllUploads = () => import('@/views/Pages/Company/CompanyAllUploads')
const MeterList = () => import('@/views/Pages/Meter/MeterList.vue')
const MeterEdit = () => import('@/views/Pages/Meter/Meter.vue')
const MeterAbsorbedPower = () => import('@/views/Pages/Meter/MeterAbsorbedPower.vue')
const Dashboard = () => import('@/views/Pages/Dashboard')
const CollaboratorList = () => import('@/views/Pages/Collaborator/CollaboratorList.vue')
const CollaboratorEdit = () => import('@/views/Pages/Collaborator/CollaboratorEdit.vue')
const Contracts = () => import('@/views/Pages/Contracts.vue')
const Report = () => import('@/views/Pages/Report.vue')

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: ROUTES.HOME,
        meta: { isProtected: true },
        redirect: { name: ROUTES.COMPANY.LIST },
    },
    { path: '/accedi', component: Login, name: ROUTES.LOGIN, meta: { isProtected: false } },
    { path: '/contatori', component: MeterList, name: ROUTES.METER.LIST, meta: { isProtected: true } },
    { path: '/aziende', component: CompanyList, name: ROUTES.COMPANY.LIST, meta: { isProtected: true } },
    { path: '/aziende/:id', component: CompanyEdit, name: ROUTES.COMPANY.EDIT, meta: { isProtected: true } },
    {
        path: '/aziende/:id/produzione',
        component: CompanyProduction,
        name: ROUTES.COMPANY.PRODUCTION,
        meta: { isProtected: true },
    },
    {
        path: '/aziende/:companyId/contatori/:meterId',
        component: MeterEdit,
        name: ROUTES.METER.DETAIL,
        meta: { isProtected: true },
    },
    {
        path: '/aziende/:companyId/contatori/:meterId/potenza-assorbita',
        component: MeterAbsorbedPower,
        name: ROUTES.METER.ABSORBED_POWER,
        meta: { isProtected: true },
    },
    {
        path: '/aziende/:companyId/tutti-i-caricamenti',
        component: CompanyAllUploads,
        name: ROUTES.COMPANY.ALL_UPLOADS,
        meta: { isProtected: true },
    },
    { path: '/holding', component: HoldingList, name: ROUTES.HOLDING.LIST, meta: { isProtected: true } },
    { path: '/holding/:id', component: HoldingEdit, name: ROUTES.HOLDING.EDIT, meta: { isProtected: true } },
    {
        path: '/collaboratori',
        component: CollaboratorList,
        name: ROUTES.COLLABORATOR.LIST,
        meta: { isProtected: true },
    },
    {
        path: '/collaboratori/:id',
        component: CollaboratorEdit,
        name: ROUTES.COLLABORATOR.EDIT,
        meta: { isProtected: true },
    },
    {
        path: '/recupera-password',
        component: ForgotPassword,
        name: ROUTES.FORGOT_PASSWORD,
        meta: { isProtected: false },
    },
    { path: '/profilo', component: Profile, name: ROUTES.PROFILE, meta: { isProtected: true } },
    {
        path: '/aziende/:id/dashboard',
        component: Dashboard,
        name: ROUTES.COMPANY.DASHBOARD,
        meta: { isProtected: true, hasGradientHeader: true },
    },
    {
        path: '/holding/:id/dashboard',
        component: Dashboard,
        name: ROUTES.HOLDING.DASHBOARD,
        meta: { isProtected: true, hasGradientHeader: true },
    },
    { path: '/contratti', component: Contracts, name: ROUTES.CONTRACTS.LIST, meta: { isProtected: true } },
    { path: '/report', component: Report, name: ROUTES.REPORT, meta: { isProtected: true, noLayout: true } },
    { path: '/:pathMatch(.*)*', component: NotFound, name: ROUTES.NOT_FOUND },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const { isLogged, tryAutoLogin } = useUser()
    tryAutoLogin()

    if (to.meta.isProtected && !isLogged.value) {
        next({ name: ROUTES.LOGIN })
    } else if ((to.name === ROUTES.LOGIN || to.name === ROUTES.FORGOT_PASSWORD) && isLogged.value) {
        next({ name: ROUTES.HOME })
    } else {
        next()
    }
})

router.onError((error, to) => {
    if (error.message.includes('Failed to fetch dynamically imported module')) {
        window.location.href = to.fullPath
    }
})

export default router
